export interface AnalystNotesListKeyArguments {
  approvalId: string;
}

/**
 * Hierarchical query-key factory for the Analyst Notes feature (OR-22625). The
 * shape mirrors the sibling dsc-notes / stipulation key factories so cache
 * invalidation stays predictable: invalidating `all` flushes every analyst-notes
 * query, `lists()` only flushes list queries, and `list({ approvalId })` flushes
 * a single deal. Never write a literal key array outside this module — the
 * factory IS the schema.
 *
 * Keyed on approvalId alone: the BFF endpoint is
 * `/api/v1/workbench/applications/{approvalId}/analyst-notes` with no query
 * params (unlike dsc-notes, which carries a `phase`).
 */
export const analystNotesKeys = {
  all: ["analystNotes"] as const,
  lists: () => [...analystNotesKeys.all, "list"] as const,
  list: (arguments_: AnalystNotesListKeyArguments) => [...analystNotesKeys.lists(), arguments_] as const,
};
